<template>
  <div class="level-box">
    <div v-if="name == 'A'" class="tag a" :class="{ mini: size == 'mini' }">低风险</div>
    <div v-else-if="name == 'B'" class="tag b" :class="{ mini: size == 'mini' }">中风险</div>
    <div v-else-if="name == 'C'" class="tag c" :class="{ mini: size == 'mini' }">高风险</div>
    <div v-else-if="name == 'D'" class="tag d" :class="{ mini: size == 'mini' }">极高风险</div>
    <div v-else class="tag none" :class="{ mini: size == 'mini' }">-</div>
  </div>
</template>

<script>
export default {
  name: 'TagLv',
  props: {
    name: {
      type: String,
      default: 'A'
    },
    size: {
      type: String,
      default: 'small'
    }
  },
  data() {
    return {}
  },

  mounted() {},

  methods: {}
}
</script>
<style lang="scss" scoped>
.level-box {
  display: inline-block;
}
.tag {
  display: inline-block;
  width: 60px;
  height: 32px;
  text-align: center;
  line-height: 32px;
  border-radius: 3px;
  color: #fff;
  font-weight: 600;
  font-size: 14px!important;
}
.mini{
  width: 40px;
  height: 20px;
  line-height: 20px;
}
.a {
  background-color: #28D576;
}
.b {
  background-color: #1483EA;
}
.c {
  background-color: #FFAC46;
}
.d {
  background-color: #D05252;
}
.none {
  background-color: #C5C5C5;
}
</style>
